class HttpException extends Error {
  public static NAME = 'HttpException';
}

export default HttpException;
